import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter as Router, Route } from 'react-router-dom';
import App from './App';
import Coding from './Coding';
import Flying from './Flying';
import Paragliding from './Paragliding';

import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/css/bootstrap-theme.min.css';
import './index.css';

ReactDOM.render((
	<Router>
	  	<div>
			<Route exact path='/' component={App} />
			<Route path='/coding' component={Coding} />
			<Route path='/flying' component={Flying} />
			<Route path='/paragliding' component={Paragliding} />
		</div>
	</Router>
), document.getElementById('root'));



// WEBPACK FOOTER //
// ./src/index.js